import mobile from '@/utils/mobile';
const isMobileApp = navigator.userAgent.indexOf('SellerCenterUserAgent') > -1;
export default {
  methods: {
    routerPush (name, params = {}, query = {}) {
      if (isMobileApp) {
        const props = this.$router.resolve({
          name,
          ...query,
          params,
        });
        const href = props.href.substr(1);
        mobile.changeUrl(`${this.$root.basePath}${href}`, name);
      } else {
        this.$router.push({
          name,
          ...query,
          params,
        });
      }
    },
  },
};
